module.exports = __webpack_public_path__ + "static/media/totalIconSemSobra.0542fd0c.svg";